export default __webpack_public_path__ + "static/media/0023.763a595f.png";